export const tailwindMergeConfig = {
  classGroups: {
    'font-size': [{ text: ['48', '40', '36', '32', '24', '20', '18', '16', '14', '12', '10', '8'] }],
  },
  extend: {
    theme: {
      // Keep in sync with cn.ts and design-system spacing tokens (18, 54).
      spacing: ['18', '54'],
    },
  },
};
